import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDueDateExpired',
  standalone: true
})
export class IsDueDateExpiredPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): boolean {
    if (!value) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const due = new Date(value);

    if (isNaN(due.getTime())) {
      return false;
    }
    return due < today;
  }
}
